import React from 'react';
import {io} from "socket.io-client";

const workspace = process.env.REACT_APP_WORKSPACE ? process.env.REACT_APP_WORKSPACE : 'production'
const IS_PRODUCTION: boolean = process.env.REACT_APP_ENVIRONMENT==='production'
const IS_KOA: boolean = process.env.REACT_APP_ENVIRONMENT==='koa'
const IS_KECK: boolean = process.env.REACT_APP_ENVIRONMENT != 'koa'

if (!process.env.REACT_APP_KAH_SERVER_URL) {
    console.log('REACT_APP_KAH_SERVER_URL missing in enviroment - Update environment with Full Ingestion Path')
}
let url = process.env.REACT_APP_KAH_SERVER_URL ? `${process.env.REACT_APP_KAH_SERVER_URL}`: "http://vmkoatest.ipac.caltech.edu:8092" 
let path = "/socket.io";
console.log(`socket@ ${url}`)

export const socket = new (io as any)(url, {path: path, transports: ['websocket'], secure: true, rejectUnauthorized: false});
//export const socket = io(url, {path: path, transports: ['websocket'], secure: true, rejectUnauthorized: false});

export const SocketContext = React.createContext(socket);
